import { render } from "./ModuleSettingsView.vue?vue&type=template&id=499c394d"
import script from "./ModuleSettingsView.vue?vue&type=script&lang=js"
export * from "./ModuleSettingsView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__